import { isValidElement } from 'react';
import isNil from 'lodash/isNil';

export const isTruthyValue = value => {
  if (isNil(value)) return false;

  if (isValidElement(value)) return true;

  if (typeof value === 'function') return true;

  const invalidStrings = ['N/A', 'n/a', 'na', 'N / A', 'NA'];
  return !invalidStrings.includes(String(value).trim().toLowerCase());
};

export const filterValidItems = items => {
  return Array.isArray(items) ? items.filter(item => !isNil(item)) : [];
};
